module.exports = __webpack_public_path__ + "img/REPLAY_logo.74374e30.svg";